import { FlexboxCenter } from "./globalStyles";

export const ErrorPage = {
    ...FlexboxCenter,
    flexDirection:'column',
    gap:'10px',
    margin:'auto',
    height:'100vh',
    textAlign:'center'
}

export const ErrorPageHeading = {
    color:'var(--main-color-orange-gold)',
    fontSize:'33px',
    fontWeight:'bold'
}